import * as React from "react"
import {Box} from "@mui/material";

import ExcelButton from "./ExcelButton";
import BannerPercentageGroupedSelect from "./GroupedSelect";
import BannerPercentageSplitBySelect from "./SplitBySelect";
import BannerPercentageMetricSelect from "./MetricSelect";


export default function BannerPercentageToolbar({
	metricSelected=null, onChangeMetric=null, splitBySelected=null, onChangeSplitBy=null, groupedBySelected, onChangeGroupedBy=null,
	excludeOptions=[], onDownload=null
}) {

	return <Box display="flex" gap={3}>
		{ !!metricSelected && <BannerPercentageMetricSelect
			value={metricSelected}
			onChange={onChangeMetric}
		/> }
		{ !!splitBySelected && <BannerPercentageSplitBySelect
			value={splitBySelected}
			onChange={onChangeSplitBy}
		/> }
		<BannerPercentageGroupedSelect
			value={groupedBySelected}
			onChange={onChangeGroupedBy}
			excludeOptions={excludeOptions}
		/>
		{ !!onDownload && <ExcelButton onClick={onDownload} /> }
	</Box>
}